import { Provider } from './provider.model';
import { User } from "./user.model";
import { Real } from "./real.model";
import { ProviderService } from "./provider-service.model";
import { Event } from "./event.model";

import * as moment from 'moment';
import 'moment-timezone';
moment.tz.setDefault("Europe/Ljubljana");

export class Activity {

  public id: string;
  public url: string;

  public name: string;
  public shortName: string;
  public longDescription  : string;
  public shortDescription: string;

  public duration: number;
  public durationInMinutes: number;


  public paymentByCard: boolean;
  public paymentByBankTransfer: boolean;
  public paymentByVoucher: boolean;
  public paymentOnSite: boolean;
  public bookletUrl: string;
  public host: string;
  public instructions: string;
  public difficulty: number;

  public updated: string;
  public root  : string;
  public children: any;
  public childrenPickMin: number;
  public minimalPrice  : string;
  public visibleForCustomers  : string;
  public visibleForEditors  : string;
  public visibleByDefaultInAdmin  : string;
  
  public avatar : any;
  public avatarHref : any;
  public menuOpen : number;

  public lft: number;
  public lvl: number;
  public rgt: number;
  public attendeesMax: number;
  public attendeesMin: number;

  public regularPrice1 : number;
  public regularPrice2 : number;
  public regularPrice3 : number;
  public regularPrice4 : number;
  public regularPrice5 : number;
  public regularPrice6 : number;
  public regularPrice7 : number;
  public regularPrice8 : number;
  public regularPrice9 : number;

  public events : Event[];

  public _self: string;

  public zajla = false;
  public vip = false;

  constructor(
    obj?: any 
  ) {
    this.id = obj && obj.id || null;
    this.updated = obj && obj.updated || null;
    this.url = obj && obj.url || null;

    this.name = obj && obj.name || null;
    this.shortName = obj && obj.shortName || null;
    this.longDescription = obj && obj.longDescription || null;
    this.shortDescription = obj && obj.shortDescription || null;

    this.duration = obj && obj.duration || null;
    this.durationInMinutes = obj && obj.durationInMinutes || null;

    this.root = obj && obj.root || null;
    this.children = obj && obj.children || null;
    this.childrenPickMin = obj && obj.childrenPickMin || null;
    this.minimalPrice = obj && obj.minimalPrice || null;
    this.visibleForCustomers = obj && obj.visibleForCustomers || null;
    this.visibleForEditors = obj && obj.visibleForEditors || null;
    this.visibleByDefaultInAdmin = obj && obj.visibleByDefaultInAdmin || null;

    this.avatar = obj && obj.avatar || null;
    this.avatarHref = obj && obj.avatarHref || null;
    this.menuOpen = obj && obj.menuOpen || false;

    this.lft = obj && obj.lft || null;
    this.lvl = obj && obj.lvl || null;
    this.rgt = obj && obj.rgt || null;
    this.attendeesMin = obj && obj.attendeesMin || null;
    this.attendeesMax = obj && obj.attendeesMax || null;

    this.regularPrice1 = ( obj && obj.regularPrice1 ) ?? null;
    this.regularPrice2 = obj && obj.regularPrice2 || null;
    this.regularPrice3 = obj && obj.regularPrice3 || null;
    this.regularPrice4 = obj && obj.regularPrice4 || null;
    this.regularPrice5 = obj && obj.regularPrice5 || null;
    this.regularPrice6 = obj && obj.regularPrice6 || null;
    this.regularPrice7 = obj && obj.regularPrice7 || null;
    this.regularPrice8 = obj && obj.regularPrice8 || null;
    this.regularPrice9 = obj && obj.regularPrice9 || null;

    this.paymentByCard = obj && obj.paymentByCard || null;
    this.paymentByBankTransfer = obj && obj.paymentByBankTransfer || null;
    this.paymentByVoucher = obj && obj.paymentByVoucher || null;
    this.paymentOnSite = obj && obj.paymentOnSite || null;
    this.bookletUrl = obj && obj.bookletUrl || null;
    this.host = obj && obj.host || null;
    this.instructions = obj && obj.instructions || null;
    this.difficulty = obj && obj.difficulty || null;

    if ( obj && obj.slug && obj.slug === 'vecerja-na-zajli' ) {
      this.zajla = true;
    }

    if ( obj && obj.slug &&  ( obj.slug === 'vip-gourmet-dozivetje-giro-d-italia' || obj.slug === 'giro-d-italia' ) ) {
      this.vip = true;
    }

    if ( obj && obj.events   ) {
       
       this.events = [];
       
       for (let e of obj.events ) {

         if ( e.start < moment().format() || e.status < 10 || e.status > 40 ) {
           continue;
         }

         if ( e instanceof Event ) {
           this.events.push( e );
         } else {


           this.events.push( new Event( e ) );
         }

       }
    }

    if ( obj && obj._self ) {
      this._self = obj._self;
    } else if ( obj && obj._links && obj._links.self && obj._links.self.href ) {
      this._self = obj._links.self.href;
    }
    
  }


}